import { apiRequest } from '@/plugins/api.js';
import { apiResponseTypeEnum } from '@/constants/api.js';

export const apiRetrieveLevelList = () => apiRequest({
  url: 'api/fetchLevels',
  method: 'GET',
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;
  const responseData = response?.data?.data?.levelDTOs;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  }

  return {
    parsedData: responseData.map((info, index) => ({ ...info, __level: index + 1 })),
  };
});
